<script lang="ts">
  import type { Snippet } from 'svelte';
  import { NetworkError } from '../shared/api/errors';
  import { auth } from '../shared/auth/auth.svelte';
  import { location, navigate } from '../shared/router/router.svelte';
  import { ErrorState, PulseLoader } from '../shared/ui';

  let { children }: { children: Snippet } = $props();

  $effect(() => {
    if (auth.status === 'anonymous') navigate('/login', { replace: true, state: { from: location.pathname } });
  });
</script>

{#if auth.status === 'restoring'}
  <PulseLoader page />
{:else if auth.status === 'unreachable'}
  <!-- Server or network down while checking the session: say so and offer a retry, never a logout. -->
  <main class="mx-auto max-w-md px-4 py-16">
    <ErrorState error={new NetworkError()} onRetry={() => auth.restoreSession()} />
  </main>
{:else if auth.status === 'authenticated'}
  {@render children()}
{/if}
